import * as amplitude from '@amplitude/analytics-browser'
import { appConfig } from 'Config/app-config.ts'

amplitude.init(appConfig.amplitudeAPIKey)
let sendAnalytics: boolean = true
const isAnalyticsEnabled: boolean = appConfig.buildEnvironment === 'production'

export function setSendAnalyticsValue(value: boolean) {
    sendAnalytics = value
}

export function sendAnalyticsTrack(eventName: string, eventParams: object) {
    if (!isAnalyticsEnabled) return
    if (!sendAnalytics) return
    amplitude.track(eventName, eventParams)
}
